import { combineReducers } from 'redux';
import queryByStoreReducer from './query-by-store/reducer';
import organizationUnitsReducer from './organizationUnits/reducer';
import libraryReducer from './library/reducer';
import countriesReducer from './countries/reducer';
import statesReducer from './states/reducer';
import themeReducer from './theme/reducer';
import userProfileReducer from './userProfile/reducer';
import websiteReducer from './website/reducer';
import storesReducer from './stores/reducer'
import userReducer from './user/reducer';
import settingsReducer from './settings/reducer';
import channelReducer from './channel/reducer';
import layoutsReducer from './layouts/reducer';
import cardsReducer from './cards/reducer';
import pagesReducer from './pages/reducer';
import websitesReducer from './websites/reducer';
import tenantsReducer from './tenants/reducer';
import tenantWebsitesReducer from './tenant-websites/reducer';
import tenantWebsiteCardsReducer from './tenant-website-cards/reducer';
import departmentsReducer from './departments/reducer';
import uploadFilesReducer from './upload-files/reducer';
import addressBooksReducer from './address-books/reducer';
import networksReducer from './networks/reducer';
import nexusARecordTypesReducer from './nexus-a-record-types/reducer';
import productsReducer from './products/reducer';
import categoriesReducer from './categories/reducer';
import nexusARecordsReducer from './nexus-a-records/reducer';
import routerReducer from './router/reducer';
import brandMappingsReducer from './brand-mappings/reducer';
import socialProfilesReducer from './social-profiles/reducer';
import templatesReducer from './templates/reducer';
import announcementsReducer from './announcements/reducer';
import policyCollectionsReducer from './collections/reducer';
import deliveriesReducer from './deliveries/reducer';
import discountsReducer from './discounts/reducer';
import helpTopicsReducer from './help-topics/reducer';
import rewardPointsReducer from './reward-points/reducer';
import tenantFunctionsReducer from './tenant-functions/reducer';
import tierPricesReducer from './tier-prices/reducer';
import metaTokensReducer from './meta-token/reducer';
import businessReducer from './businesses/reducer';
import businessUserReducer from './business-users/reducer';
import projectsReducer from './projects/reducer';
import ticketsReducer from './tickets/reducer';
import ticketActivitiesReducer from './ticket-activities/reducer';
import serviceRequestsReducer from './service-requests/reducer';
import accountsReducer from './accounts/reducer';
import accountTypesReducer from './account-types/reducer';
import employeesReducer from './employees/reducer';
import EsbAuditLogReducer from './esb-audit-logs/reducer';
import zoneReducer from './zone/reducer';
import { node } from './node/action';
import nodeReducer from './node/reducer';

const appReducer = combineReducers({
	accounts: accountsReducer,
	accountTypes: accountTypesReducer,
	employees: employeesReducer,
	projects: projectsReducer,
	tickets: ticketsReducer,
	ticketActivities: ticketActivitiesReducer,
	serviceRequests: serviceRequestsReducer,
	business: businessReducer,
	businessUser: businessUserReducer,
	metaTokens: metaTokensReducer,
	announcements: announcementsReducer,
	policyCollections: policyCollectionsReducer,
	deliveries: deliveriesReducer,
	discounts: discountsReducer,
	helpTopics: helpTopicsReducer,
	rewardPoints: rewardPointsReducer,
	tenantFunctions: tenantFunctionsReducer,
	tierPrices: tierPricesReducer,
	templates: templatesReducer,
	socialProfiles: socialProfilesReducer,
	brandMappings: brandMappingsReducer,
	settings: settingsReducer,
	theme: themeReducer,
	user: userReducer,
	channel: channelReducer,
	queryByStore: queryByStoreReducer,
	organizationUnits: organizationUnitsReducer,
	library: libraryReducer,
	countries: countriesReducer,
	states: statesReducer,
	websites: websitesReducer,
	userProfile: userProfileReducer,
	layouts: layoutsReducer,
	cards: cardsReducer,
	pages: pagesReducer,
	website: websiteReducer,
	stores: storesReducer,
	tenants: tenantsReducer,
	tenantWebsiteCards: tenantWebsiteCardsReducer,
	tenantWebsites: tenantWebsitesReducer,
	departments: departmentsReducer,
	uploadFiles: uploadFilesReducer,
	addressBooks: addressBooksReducer,
	networks: networksReducer,
	products: productsReducer,
	categories: categoriesReducer,
	nexusARecords: nexusARecordsReducer,
	nexusARecordTypes: nexusARecordTypesReducer,
	router: routerReducer,
	esbAuditLog: EsbAuditLogReducer,
	zone: zoneReducer,
	node: nodeReducer,

});

const rootReducer = (state: any, action: any) => {

	return appReducer(state, action);
};

export default rootReducer;
